var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142.56,
    height: 64.249,
    viewBox: "0 0 142.56 64.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8004",
    "data-name": "Rectangle 8004",
    width: 142.56,
    height: 64.249,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5923",
    "data-name": "Group 5923",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5922",
    "data-name": "Group 5922",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28013",
    "data-name": "Path 28013",
    d: "M72.515,81.379V72.551a3.285,3.285,0,1,1,6.57,0v8.828h3.338V72.551a3.285,3.285,0,1,1,6.571,0v8.828h3.479V72.393A6.643,6.643,0,0,0,80.7,68.17a6.643,6.643,0,0,0-11.77,4.223v8.986Z",
    transform: "translate(-18.589 -17.731)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28014",
    "data-name": "Path 28014",
    d: "M138.059,62.71a7.922,7.922,0,0,0-4.262,1.236l-.077-9.45h-3.632V70.685a7.972,7.972,0,1,0,7.972-7.972m0,12.6a4.622,4.622,0,0,1-4.622-4.622l.085-.883a4.623,4.623,0,1,1,4.538,5.507",
    transform: "translate(-35.08 -14.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8002",
    "data-name": "Rectangle 8002",
    width: 3.484,
    height: 15.334,
    transform: "translate(113.415 48.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28015",
    "data-name": "Path 28015",
    d: "M159.038,58.589a2.315,2.315,0,1,1-2.315-2.314,2.315,2.315,0,0,1,2.315,2.314",
    transform: "translate(-41.639 -15.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8003",
    "data-name": "Rectangle 8003",
    width: 3.734,
    height: 24.847,
    transform: "translate(119.996 38.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28016",
    "data-name": "Path 28016",
    d: "M185,76.644a4.85,4.85,0,0,1-8.711-1.87h12.844a8.136,8.136,0,1,0-1.168,3.344Zm-3.95-7.668a4.851,4.851,0,0,1,4.38,2.759h-8.76a4.851,4.851,0,0,1,4.38-2.759",
    transform: "translate(-46.63 -17.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28017",
    "data-name": "Path 28017",
    d: "M1.075,36.3H8.335q1.123,0,1.124-1.051V24.226h3.961l5.94,11.17a1.108,1.108,0,0,0,.427.66,1.219,1.219,0,0,0,.746.244h8.382a1.069,1.069,0,0,0,.7-.209.722.722,0,0,0,.256-.6,1.675,1.675,0,0,0-.268-.8q-.269-.466-.44-.8l-6.28-11.834a12.542,12.542,0,0,0,2.432-1.821,11.958,11.958,0,0,0,1.924-2.376A11.81,11.81,0,0,0,28.5,15.046a10.9,10.9,0,0,0,.453-3.168,11.43,11.43,0,0,0-.941-4.607,11.934,11.934,0,0,0-2.579-3.782A12.308,12.308,0,0,0,21.586.945,11.871,11.871,0,0,0,16.865,0H1.075a1.017,1.017,0,0,0-.8.306A1.189,1.189,0,0,0,0,1.127V35.253a1,1,0,0,0,.294.792,1.144,1.144,0,0,0,.781.257M9.46,7.488h3.373q.709,0,1.309.037t1.283.085a4.021,4.021,0,0,1,1.515.539A4.4,4.4,0,0,1,18.107,9.18a4.789,4.789,0,0,1,.761,1.339,4.231,4.231,0,0,1,.268,1.471,4.847,4.847,0,0,1-.244,1.528,4.437,4.437,0,0,1-.711,1.345,4.026,4.026,0,0,1-1.146,1,3.867,3.867,0,0,1-1.54.5c-.276.032-.529.058-.757.072s-.489.026-.783.026H9.46Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28018",
    "data-name": "Path 28018",
    d: "M127.4,28.19a1.173,1.173,0,0,0-.782-.268H109.827L127.52,6.837a1.393,1.393,0,0,0,.134-.44c.008-.115.012-.237.012-.367V1.088a.983.983,0,0,0-.329-.8,1.227,1.227,0,0,0-.792-.271H98.167a1.178,1.178,0,0,0-.844.294,1.033,1.033,0,0,0-.305.781V7.205a1.194,1.194,0,0,0,.305.917,1.206,1.206,0,0,0,.844.28h16.742L97.263,29.211a1.1,1.1,0,0,0-.171.636v5.258a1.173,1.173,0,0,0,.329.882,1.132,1.132,0,0,0,.818.316h28.377a.961.961,0,0,0,.792-.391,1.3,1.3,0,0,0,.306-.8V29.037a1.033,1.033,0,0,0-.317-.831",
    transform: "translate(-26.161 -0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28019",
    "data-name": "Path 28019",
    d: "M165.343,2.113,164.733.719a3.192,3.192,0,0,0-.441-.453,1.037,1.037,0,0,0-.708-.256h-6.257a1.153,1.153,0,0,0-.415.085,1.818,1.818,0,0,0-.746.551.713.713,0,0,0-.159.317l-13.27,34.365a.573.573,0,0,0,.115.733,1.193,1.193,0,0,0,.771.244h7.211a1.222,1.222,0,0,0,1.244-.9l7.423-21.23.96-2.75,8.082,23.253c.094.242.183.481.279.724a1.339,1.339,0,0,0,.476.7,1.529,1.529,0,0,0,.867.208h7.013a1.183,1.183,0,0,0,.93-.3.719.719,0,0,0,.073-.792Z",
    transform: "translate(-38.469 -0.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28020",
    "data-name": "Path 28020",
    d: "M67.24,2.113,66.63.719a3.192,3.192,0,0,0-.441-.453,1.042,1.042,0,0,0-.708-.256H59.223A1.153,1.153,0,0,0,58.809.1a1.818,1.818,0,0,0-.746.551A.713.713,0,0,0,57.9.963L44.633,35.328a.573.573,0,0,0,.115.733,1.193,1.193,0,0,0,.771.244h7.211a1.224,1.224,0,0,0,1.244-.9L61.4,14.171c.007-.02.012-.039.018-.058q.479-1.441.942-2.688L70.44,34.678c.094.242.183.481.278.724a1.336,1.336,0,0,0,.477.7,1.525,1.525,0,0,0,.866.208h7.016a1.184,1.184,0,0,0,.93-.3.72.72,0,0,0,.073-.792Z",
    transform: "translate(-12.013 -0.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28021",
    "data-name": "Path 28021",
    d: "M111.8,71.662a.372.372,0,0,0,.372-.372V70.008a.372.372,0,1,0-.745,0v1.282a.372.372,0,0,0,.372.372",
    transform: "translate(-30.049 -18.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28022",
    "data-name": "Path 28022",
    d: "M112.133,63.476a8.925,8.925,0,1,0,8.925,8.925,8.925,8.925,0,0,0-8.925-8.925m4.415,14.3a1.081,1.081,0,0,1-1.081,1.081H108.8a1.081,1.081,0,0,1-1.081-1.088l.069-10.75a1.081,1.081,0,0,1,1.081-1.074h2.826a1.081,1.081,0,0,1,.751.3l3.773,3.643a1.08,1.08,0,0,1,.33.778Z",
    transform: "translate(-27.832 -17.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28023",
    "data-name": "Path 28023",
    d: "M113.857,71.662a.372.372,0,0,0,.372-.372V70.008a.372.372,0,1,0-.745,0v1.282a.372.372,0,0,0,.372.372",
    transform: "translate(-30.603 -18.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28024",
    "data-name": "Path 28024",
    d: "M115.585,76.149h-4.324a.767.767,0,0,0-.767.767v3.8a.767.767,0,0,0,.767.768h4.324a.767.767,0,0,0,.767-.768v-3.8a.767.767,0,0,0-.767-.767m-2.542,4.457h-1.675V79.194h1.675Zm0-2.171h-1.675V77.024h1.675Zm2.433,2.171H113.8V79.194h1.675Zm0-2.171H113.8V77.024h1.675Z",
    transform: "translate(-29.797 -20.535)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a28ac56aa3e853bda531888ae23f3c2.svg";
export { ForwardRef as ReactComponent };